<template>
    <div>
    <button
        :class="{
            'add-to-cart': true,
            'add-to-cart--loading': isLoading,
            'add-to-cart--active': inCart,
        }"
        v-on="$listeners"
        :disabled="isLoading || inCart"
    >
        <span v-if="isLoading" class="spinner-border spinner-border-sm" />
        <slot />
    </button>
    </div>
</template>

<script>
export default {
    name: 'to-cart-btn',

    inject: ['$basketService'],

    props: {
        inCart: {
            type: Boolean,
        },

        isLoading: {
            type: Boolean,
        },
    },
};
</script>
